<template>
  <div :class="item.class" class="construct-visual-column" :style="columnStyle">
    <Renderer :content="item.content || []" :line="line" :page="page" :itemData="itemData" :actionResolver="actionResolver" @action="$emit('action', $event)" />
  </div>
</template>

<script>
import displayMixin from './mixin'

export default {
  name: 'ConstructVisualDisplayColumn',
  mixins: [displayMixin],
  components: { Renderer: () => import('./Renderer.vue') },
  computed: {
    columnStyle() {
      return {
        width: this.item.width || undefined,
        textAlign: { start: 'left', end: 'right' }[this.item.align] || this.item.align || undefined,
      }
    },
  },
}
</script>

<style scoped>
.construct-visual-column { min-width: 0; }
</style>
